<template>
  <div>
    <div
      id="dashboard-balance-widget"
      :class="isLoading ? 'panel-body chart widget-loader' : 'panel-body chart'"
    >
      <canvas id="canvas"></canvas>
    </div>
  </div>
</template>
<style>
canvas {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>

<script>
import WidgetService from "@/services/WidgetService";
import EventBus from "@/event-bus";
import AccountService from "@/services/AccountService";

let srv = new WidgetService();
let accountService = new AccountService();

export default {
  name: "balance-widget",
  data() {
    return {
      isLoading: false
    };
  },
  props: {
    from: "",
    to: ""
  },
  created() {
    EventBus.$on('onUpdateDefaultMt4Account', (r)=>{
      this.populateComponent(r);
    });
    this.populateComponent(null);
  },
  methods: {
    populateComponent(mt4) {
      this.isLoading = true;
      
      if (mt4 == null){
        accountService
        .getDefaultMt4Account()
        .then(r => {
          return r;
        })
        .then(r => {
          srv.getBalanceWidget(r.data.login).then(r => {
            var balanceWidgetJs = document.getElementById("balanceWidgetJs");
            var js = '<script id="balanceWidgetJs">' + r.data + "<\/script>";
            if (balanceWidgetJs) {
              $(balanceWidgetJs).remove();
            }
            $("body").append($(js));
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
      }else{
         srv.getBalanceWidget(mt4.login).then(r => {
            var balanceWidgetJs = document.getElementById("balanceWidgetJs");
            var js = '<script id="balanceWidgetJs">' + r.data + "<\/script>";
            if (balanceWidgetJs) {
              $(balanceWidgetJs).remove();
            }
            $("body").append($(js));
          }).finally(() => {
          this.isLoading = false;
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/BalanceWidget.vue